import TourPackageHttp from "../../tourPackageHttp";

class PlaceServices {
  static async getPlaces() {
    return TourPackageHttp.get("/allPlaces");
  }
  static async getPlaceById(id) {
    return TourPackageHttp.get(`/places/${id}`);
  }
  // static async getDriverTripcount(id){
  //     return Http.get(`/rider-trip-counts/${id}`);
  // }
  static async updatePlace(id, data) {
    console.log(
      "========================================data in the updatePlace",
      data
    );
    return TourPackageHttp.update(`/places/${id}`, data);
  }
  static async addPlace(data) {
    return TourPackageHttp.post("/places/create", data);
  }

  static async deletePlace(id) {
    return TourPackageHttp.delete(`/places/${id}`);
  }
}
export default PlaceServices;
